module.exports = __webpack_public_path__ + "img/puzzle1-700.5f628179.png";